export function ChevronUpIcon({
  size = 12,
  collapsed = false,
  strokeWidth = 2.5,
}: { size?: number; collapsed?: boolean; strokeWidth?: number } = {}) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} stroke="currentColor" fill="none" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
      style={{ transform: collapsed ? 'rotate(180deg)' : 'none', transition: 'transform .15s ease', flexShrink: 0 }}>
      <polyline points="18 15 12 9 6 15"/>
    </svg>
  )
}
